var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M20,11H5.3L8.6,7.7a.967.967,0,0,0,0-1.4h0a.967.967,0,0,0-1.4,0L1.5,12l6.2,6.2a.967.967,0,0,0,1.4,0h0a.967.967,0,0,0,0-1.4L5.3,13H20a.945.945,0,0,0,1-1h0A.945.945,0,0,0,20,11Z",
    fill: "#111"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack24Px);
export default __webpack_public_path__ + "static/media/back-24px.01409021.svg";
export { ForwardRef as ReactComponent };